<template>
    <div class="cp-store-locator">
        <div class="cp-store-locator__side">
            <slot name="search" :labels="labels" :config="config.search">
                <CpStoreLocatorSearch :labels="labels" :config="config.search"></CpStoreLocatorSearch>
            </slot>

            <slot name="list" :stores="displayedStores" :labels="labels">
                <CpStoreLocatorList :stores="displayedStores" :labels="labels"></CpStoreLocatorList>
            </slot>
        </div>

        <div class="cp-store-locator__mapside">
            <slot name="map" :stores="displayedStores" :labels="labels" :config="computedMapConfig">
                <CpStoreLocatorMap :stores="displayedStores" :labels="labels" :config="computedMapConfig"></CpStoreLocatorMap>
            </slot>

            <div class="cp-store-locator__modal" v-if="modalVisible">
                <button class="cp-store-locator__modal__close" @click="handleClose">{{  labels.close }} <i class="fal fa-times"></i></button>

                <slot name="modal" :store="activeStore"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import CpStoreLocatorSearch from "./CpStoreLocatorSearch";
import CpStoreLocatorList from "./CpStoreLocatorList";
import CpStoreLocatorMap from "./CpStoreLocatorMap";
import slugify from '../../helpers/slugify';
import deepMap from "../../helpers/deepMap";

export default {
    name: "cp-store-locator",
    components: {
        CpStoreLocatorSearch,
        CpStoreLocatorList,
        CpStoreLocatorMap,
    },
    props: {
        stores: {
            type: Array,
            required: true,
        },
        labels: {
            type: Object,
            required: true,
        },
        config: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            filters: [],
            storesList: [],
            displayedStores: [],
            modalVisible: false,
            activeStore: {},
        };
    },
    computed: {
        computedMapConfig() {
            return deepMap(this.config.map, (v) => parseFloat(v));
        },
    },
    methods: {
        /**
         * Format given stores.
         */
        formatStores() {
            this.storesList = [].concat( this.stores ).map( store => {
                store.uid = this.$actions.uid( store );

                return store;
            } );

            this.setDisplayedMarkers();
        },

        handleClose() {
            this.$events.emit('disable-marker');
        },

        setDisplayedMarkers(selected = null) {
            if (selected) {
                return this.displayedStores = this.storesList.filter( store => selected.indexOf( store.uid ) > -1);
            }

            return this.displayedStores = [].concat( this.storesList );
        },
    },
    beforeMount() {
        this.$actions.register('loading', status => {
            this.isLoading = status;
        } );

        this.$actions.register('uid', ({lat, lng, name}) => {
            return slugify(`marker-${lat}-${lng}-${name}`);
        } );

        this.$actions.register('registerFilter', callback => {
            this.filters.push( callback );
        } );

        this.$actions.register('applyFilters', () => {
            this.displayedStores = this.filters.reduce( ( acc, callback ) => callback( acc ), this.storesList );
            this.$events.emit('after-apply-filters', this.displayedStores );

            // this.setDisplayedMarkers();
        } );
    },
    mounted() {
        this.formatStores();

        this.$events.on('disable-marker', () => {
            this.modalVisible = false;
            this.activeStore = {};
        });

        this.$events.on('active-marker', uid => {
            this.modalVisible = true;
            this.activeStore = this.storesList.find( store => store.uid === uid);
        });

        this.$events.on('set-displayed-markers', selected => this.setDisplayedMarkers( selected ) );
    },
};
</script>
